<template>
  <div
    v-if="isShowLogin"
    class="login"
    @touchmove.prevent>
    <div class="login-box">
      <p class="title">登录/注册</p>
      <div class="contain">
        <div class="ipt-box flex">
          <img src="https://cdn.51ljb.cn/ljb_icons_login_phone.png">
          <input
            v-model="phoneNumber"
            class="phone"
            placeholder="请填写手机号码"
            type="number"
            @blur="blurFn">
        </div>
        <div class="ipt-box flex" style="margin-top: 10px">
          <img src="https://cdn.51ljb.cn/ljb_icons_login_yzm.png">
          <input
            v-model="code"
            class="code"
            placeholder="请填写手机验证码"
            type="number"
            @input="()=>{if(code.length>6)code=code.slice(0,6)}"
            @blur="blurFn">
          <span
            class="getCode flex1"
            @click="getCode">{{ codeText }}</span>
        </div>
      </div>
      <div class="ljb-x-padding">
        <NormalBtn
          :big-btn="true"
          :btn-text="btnText"
          @btnClick="btnClick"/>
        <p class="registration">注册/登录代表您已同意<a @click="phoneNumber='', code=''"
          href="https://app.51ljb.cn/app-h5/agreement/registration.html">《律家保用户注册协议》</a></p>
        <p class="registration">注：会员用户请使用会员卡绑定手机号登录</p>
      </div>
    </div>
    <img
      class="close"
      src="https://cdn.51ljb.cn/close.png"
      @click="close">
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {Toast, Popup} from 'vant'
import NormalBtn from '@/components/common/NormalBtn'

export default {
  name: 'LjbLogin',
  components: {NormalBtn, Popup},
  model: {
    prop: 'isShow',
    event: 'close'
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      btnText: '登录/注册',
      flag: 1,
      phoneNumber: '',
      codeText: '获取验证码',
      code: ''
    }
  },
  computed: {
    ...mapGetters('User', [
      'getUserInfo',
      'getShowLogin'
    ]),
    isShowLogin () {
      let isShow = this.getShowLogin
      if (isShow) {
        document.querySelector('body').setAttribute('id', 'bd-fix')
      } else {
        document.querySelector('body').removeAttribute('id')
      }
      return isShow
    }
  },
  methods: {
    temporaryRepair () {
      var currentPosition, timer
      var speed = 1// 页面滚动距离
      timer = setInterval(function () {
        currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        currentPosition -= speed
        window.scrollTo(0, currentPosition)// 页面向上滚动
        currentPosition += speed // speed变量
        window.scrollTo(0, currentPosition)// 页面向下滚动
        clearInterval(timer)
      }, 1)
    },
    blurFn () {
      if (this.$utils.isWxgzh()) {
        this.temporaryRepair()
      }
    },
    getCode: function () {
      if (!this.phoneNumber) {
        this.$toast('请输入手机号')
        return
      }
      let VerifiTel = /^1[3-9]\d{9}$/
      if (!VerifiTel.test(this.phoneNumber)) {
        // ShowToast('请输入正确的手机号码');
        Toast('请输入正确的手机号码')
        return false
      }
      if (!this.flag) return
      this.flag = 0
      console.log(this.phoneNumber)
      this.$post.getCode(
        {
          mobile: this.phoneNumber
        }
      )
        .then((response) => {
          let num = 60
          let timer = setInterval(() => {
            num--
            this.codeText = '已发送(' + num + '秒)'
            if (num === 0) {
              this.codeText = '获取验证码'
              this.flag = 1
              clearInterval(timer)
            }
          }, 1000)
        })
        .catch((errorRes) => {
          this.flag = 1
          console.log(errorRes)
        })
    },
    // 登陆
    btnClick: function () {
      if (!this.phoneNumber) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.code) {
        this.$toast('请输入验证码')
        return
      }
      let req = {
        mobile: this.phoneNumber,
        code: this.code
      }
      this.$store.dispatch('User/login', req)
    },
    close: function () {
      this.$store.commit('User/setShowLogin', false)
      // 如果是进个人中心页
      console.log(this.$route.path)
      if (this.$route.path === '/User') {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .login{
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 201;
    text-align: center;
  }
  .login-box {
    background: #fff;
    background-size: 100% 75px;
    margin-top: 30%;
    box-sizing: border-box;
    padding-top:0;
    width: 345px;
    height: auto;
    margin-left: 15px;
    border-radius: 8px;
    padding-bottom:20px;
    .title {
      border-top-left-radius: 5px;
      border-top-right-radius:  5px;
      background: #fff;
      font-size: 18px;
      height: 70px;
      line-height: 75px;
      font-weight: 500;
      color: #333;
      letter-spacing: 1px;
      text-align: center;
    }
    .contain{
      padding:0px 30px 20px ;
    }
    .ipt-box {
      width: 100%;
      height: 40px;
      color: #333;
      img{
        width: 15px;
        height: 15px;
        vertical-align: middle;
        margin-top: 12px;
      }
      input {
        border: none;
        background: #fff;
        height: 39px;
        font-size: 14px;
        text-align: left;
        width: 58%;
        margin-left: 15px;
        border-bottom: 1px solid #EEEEEE;
        &.phone {
          width: calc(100% - 30px);
          border-bottom: 1px solid #EEEEEE;
        }
      }
      .getCode {
        color: #B98727;
        border-bottom: 1px solid #EEEEEE;
        font-size: 14px;
        line-height: 39px;
        display: block;
        box-sizing: border-box;
        // border-left: 1px solid #eee;
        text-align: center;
        width: 38%;
      }
    }

  }
  .registration{
    font-size: 12px;
    color: #aaa;
    line-height: 15px;
    text-align: left;
    margin-top: 5px;
    text-align: center;
    .protocol{
      color: #999;
    }
    >a{
      color: #0080FE;
    }
  }
  .registration:nth-child(2){
    margin-top: $padding;
  }
  .login .close{
    width: 30px;
    height: 30px;
    margin-top: 25px;

  }
</style>



// WEBPACK FOOTER //
// src/components/common/LjbLogin.vue